import { useState, useCallback } from "react";
import dayjs from "dayjs";
import { API_ENDPOINTS } from "../config/api/apiCall";


export const useDespatchPlan = ({  
  FinancierYear,
  showError,
}) => {
  const [dispatchList, setDispatchList] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadDespatchPlanList = useCallback(
    async (fromDate, toDate ,cono) => {
      if (!fromDate) {
        showError("Please select the from date", "warning");
        return;
      }
      if (!toDate) {
        showError("Please select the to date", "warning");
        return;
      }

      const formattedFromDate = dayjs(fromDate).format("DD/MMM/YYYY");
      const formattedToDate = dayjs(toDate).format("DD/MMM/YYYY");

      const requestBody = {
        SearchFromDate: formattedFromDate,
        SearchToDate: formattedToDate,
        DespatchOrderNo: cono ? cono : null,
        ConstructedGlobalValues: {
          COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
          COMPANY_ID: localStorage.getItem("companyid"),
        },
      };

      try {
        setLoading(true);
        const response = await fetch(API_ENDPOINTS.loadDespatchPlanList, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error("Unable to load despatch plan details");
        }

        const data = await response.json();

        const formattedData = data.map((row, index) => {
          //const dateOnly = new Date(row.DespatchOrderDate).toLocaleDateString();
          return { ...row, id: index + 1 };
        });

        setDispatchList(formattedData);
      } catch (error) {
        showError("Unable to load despatch plan details", "error");
      } finally {
        setLoading(false);
      }
    },
    [API_ENDPOINTS, FinancierYear, showError]
  );

  return { dispatchList, loadDespatchPlanList, loading };
};
